<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Web Application Development</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Web Application Development</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>What is Web Design?</h3>
                    <p>Web design is a fundamental process that connects content and user interface. In the age of
                        digitalization, we live in a
                        world where information is key to success. It is an important element of your business or
                        organization’s digital
                        strategy because it helps your users easily find and use your content.
                    </p>
                    <h3>What is Web Development?</h3>
                    <p>Web development is a well-defined and organized process of building and maintaining websites and
                        web applications.

                        Web development involves web design, web content development, client-side/server-side scripting
                        and network security
                        configuration.</p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Web design</li>
                                    <li><i class="flaticon-check"></i> Web development</li>
                                    <li><i class="flaticon-check"></i> Web support</li>
                                    <li><i class="flaticon-check"></i> Web maintainance</li>
                                    <li><i class="flaticon-check"></i> Web infra setup</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="text-result">
                        <h3>Why do we need it?</h3>
                        <p>A website is an online place that helps you advertise your business offers.
                            It offers a platform to reach out to a far-and-wide global customer base.
                            You can communicate with your customers and allow them to express themselves.
                            You can also have the possibility to influence your readers through your blogs on a website.
                            You can demonstrate all your ideas and publish them on a website.</p>
                    </div>


                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Angular</a></li>
                        <li><a routerLink="/technology-expertise">Java</a></li>
                        <li><a routerLink="/technology-expertise">.Net</a></li>
                        <li><a routerLink="/technology-expertise">NodeJS</a></li>
                        <li><a routerLink="/technology-expertise">MSSQL</a></li>
                        <li><a routerLink="/technology-expertise">MySQL</a></li>
                        <li><a routerLink="/technology-expertise">Azure Devops</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/mobile-development-services">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/mobile-development-services">Mobile Application Development</a>
                        </h3>
                        <span>Using Android, IOS etc</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/desktop-development-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/desktop-development-services">Desktop Application Development</a>
                        </h3>
                        <span>Using .Net, Java</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/ecommerce-development-services">
                            <img src="assets/img/services/services-10.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/ecommerce-development-services">Ecommerce Solutions</a>
                        </h3>
                        <span>Using Development Languages</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->